import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthService } from './auth.service';

import { Environment } from '@app/core/_shared/interfaces/environment/environment.interface';
import { SessionStorage } from '@app/core/_shared/services/storage/storage.service';

declare const environment: Environment;
declare global {
  interface Window {
    Cypress: any;
    msw: any;
    hj: any;
  }
}
@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(private auth: AuthService) {}

  async canActivate(): Promise<boolean> {
    if (this.isMockServiceWorkerActive()) {
      return true;
    }

    if (await this.isUserLoggedIn()) {
      return true;
    }

    this.handleRedirectForShippingDocuments();
    return await this.redirectToLogin();
  }

  isMockServiceWorkerActive(): boolean {
    return !!window.msw;
  }

  async isUserLoggedIn(): Promise<boolean> {
    const isLoggedIn = this.auth.loggedIn();
    if (isLoggedIn) {
      return true;
    }
    return false;
  }

  handleRedirectForShippingDocuments(): void {
    const currentPath = window.location.pathname;
    const shippingDocumentsRoute = '/shipping-documents';

    if (currentPath.includes(shippingDocumentsRoute)) {
      const params = new URLSearchParams(window.location.search);
      if (params.get('product_id') === 'sign') {
        SessionStorage.setItem('redirect_url', shippingDocumentsRoute);
      }
    }
  }

  async redirectToLogin(): Promise<boolean> {
    const redirectUrl = await this.auth.startPKCEAuthenticationFlow();
    window.location.href = redirectUrl;
    return false;
  }
}
